/**
 * @file Post Social.
 */

import { gsap } from 'gsap';
import * as focusTrap from 'focus-trap';

/**
 * Post Social component.
 */
const vPostSocial = () => {
	const postSocial = document.querySelector('.v-post-social');

	if (!postSocial) {
		return;
	}

	const trigger = postSocial.querySelector('.v-post-social__trigger');
	const overlay = postSocial.previousElementSibling.classList.contains('v-post-social__overlay') ? postSocial.previousElementSibling : null;
	const close = postSocial.querySelector('.v-post-social__close');
	const wrap = postSocial.querySelector('.v-post-social__wrap');

	let trap;

	const animation = gsap.timeline({
		defaults: {
			ease:     'sine.out',
			duration: 0.3,
		},
		paused:  true,
		onStart: () => {
			trigger.classList.add('v-post-social__trigger--open');
			if (trap) {
				trap.activate();
			}
		},
		onReverseComplete: () => {
			trigger.classList.remove('v-post-social__trigger--open');
			if (trap) {
				trap.deactivate();
			}
		},
	})
		.to(overlay, {
			opacity: 0.64,
		})
		.to(wrap, {
			'--clip': '0%',
		}, '<');

	trap = focusTrap.createFocusTrap(wrap, {
		clickOutsideDeactivates: false,
		onDeactivate:            () => {
			animation.reverse();
		},
	});

	trigger.addEventListener('click', () => {
		animation.play();
	});

	close.addEventListener('click', () => {
		animation.reverse();
	});

	let previousSize;

	const resizeObserver = new ResizeObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.contentBoxSize || !entry.contentBoxSize[0]?.inlineSize) {
				return;
			}

			if (!previousSize) {
				previousSize = entry.contentBoxSize[0].inlineSize;
				return;
			}

			if (entry.contentBoxSize[0].inlineSize < 150 && previousSize >= 150) {
				if (animation.progress() > 0 && !animation.reversed()) {
					animation.reverse();
				}
			}

			previousSize = entry.contentBoxSize[0].inlineSize;
		});
	});

	resizeObserver.observe(postSocial);
};

export default vPostSocial;
